import * as yup from 'yup';

export interface OneTimeVerificationSms {
  phoneNumber: string;
  verificationCode: string;
}

export interface OneTimeClubVerificationEmail {
  emailAddress: string;
  verificationCode: string;
}

export interface OneTimeVerificationRegister {
  dateOfBirth: string;
}

const validationMessages = {
  required: 'Required field',
  email: 'Enter a valid email address',
  emailMatch: 'Enter the email associated with your AAA account',
  phoneNumber: 'Please enter a valid phone number',
  validDate: 'Enter a valid date of birth (MM/DD/YYYY)',
};

export const oneTimeVerificationSmsSchema = (formSubmitted: boolean) =>
  yup.object({
    phoneNumber: yup
      .string()
      .length(14, validationMessages.phoneNumber)
      .required(validationMessages.required),
    verificationCode: yup.string().when('phoneNumber', {
      is: () => formSubmitted,
      then: yup.string().required(validationMessages.required),
    }),
  });

export const oneTimeClubVerificationEmailSchema = (
  emailMatch: string,
  formSubmitted: boolean
) =>
  yup.object({
    emailAddress: yup
      .string()
      .required(validationMessages.required)
      .min(2, validationMessages.email)
      .email(validationMessages.email)
      .matches(/\.[A-Za-z]{2,}$/, validationMessages.email)
      .test('matches-email', validationMessages.emailMatch, (value) => {
        return value?.toLowerCase() === emailMatch?.toLowerCase();
      }),
    verificationCode: yup.string().when('emailAddress', {
      is: () => formSubmitted,
      then: yup.string().required(validationMessages.required),
    }),
  });

export const registerOneTimeVerificationCodeSchema = yup.object({
  dateOfBirth: yup
    .string()
    .required(validationMessages.required)
    .length(10, validationMessages.validDate)
    .test('isValidDate', validationMessages.validDate, (value) => {
      if (!value) return false;
      // Convert the value to a Date object
      const date = new Date(value);

      // Check if the date is a valid date
      if (isNaN(date.getTime())) return false;

      // Check if the date is more than 16 years ago
      const sixteenYearsAgo = new Date();
      sixteenYearsAgo.setFullYear(sixteenYearsAgo.getFullYear() - 16);

      return date < sixteenYearsAgo;
    }),
});
